import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ApiToken } from './model/ApiToken';
import { GenerateApiTokenRequest } from './model/GenerateApiTokenRequest';

export interface GenerateApiTokenResponse {
    apiToken: string;
}
@Injectable({
    providedIn: 'root'
})
export class ApiTokensService {
    private readonly BASE_URL: string = '/rest/apiTokens';
    private apiTokensSubject = new BehaviorSubject<ApiToken[]>(null);
    apiTokens$ = this.apiTokensSubject.asObservable();

    constructor(private http: HttpClient) {}

    loadApiTokens(companyId): Observable<ApiToken[]> {
        return this.http.get<ApiToken[]>(this.BASE_URL, { params: { companyId } }).pipe(
            tap((apiTokens) => {
                this.apiTokensSubject.next(apiTokens);
            }),
            catchError((err) => {
                console.log('failed to get api-tokens ', err);
                return throwError(err);
            })
        );
    }

    generateApiToken(generateRequest: GenerateApiTokenRequest): Observable<GenerateApiTokenResponse> {
        return this.http.post<GenerateApiTokenResponse>(this.BASE_URL, generateRequest).pipe(
            catchError((err) => {
                console.log('failed to generate api-token ', err);
                return throwError(err);
            })
        );
    }

    updateToken(apiTokenId: string, newTokenName: string): Observable<void> {
        return this.http.put<void>(`${this.BASE_URL}/${apiTokenId}?newTokenName=${newTokenName}`, {}).pipe(
            catchError((err) => {
                console.log('failed to update api-token ', err);
                return throwError(err);
            })
        );
    }

    revokeApiTokens(apiTokensIds: string[]): Observable<void> {
        return this.http.put<void>(`${this.BASE_URL}/revoke`, apiTokensIds).pipe(
            catchError((err) => {
                console.log('failed to revoke api-tokens ', err);
                return throwError(err);
            })
        );
    }
}
